<div class="ticket-container">
  @if (ticket) {
    <mat-card class="ticket-detail">
      <mat-card-header>
        <mat-card-title>{{ ticket.title }}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ ticket.body }}</p>
      </mat-card-content>
      <mat-card-actions>
        <mat-form-field appearance="outline">
          <mat-label>Status</mat-label>
          <mat-select [value]="ticket.status" (selectionChange)="onStatusChange($event)" [disabled]="isStatusDisabled">
            @for (status of statuses; track status) {
              <mat-option [value]="status">
                {{ status === 'OPEN' ? 'Aberto' : status === 'IN_PROGRESS' ? 'Em Andamento' : 'Fechado' }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </mat-card-actions>
    </mat-card>
  }

  <div class="comments-section">
    <div class="comments-header">
      <h3>Comentários</h3>
      <div>
        @if (!isAddingComment) {
          <button mat-raised-button color="primary" (click)="startAddingComment()">
            <mat-icon>add_circle</mat-icon>
            Adicionar
          </button>
        }
      </div>
    </div>

    @if (isAddingComment) {
      <div class="add-comment">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Novo comentário</mat-label>
          <textarea matInput [formControl]="commentForm.get('body')" rows="4"></textarea>
          @if (commentForm.get('body')?.hasError('required')) {
            <mat-error>
              O comentário é obrigatório
            </mat-error>
          }
        </mat-form-field>
        <div class="comment-actions">
          <button mat-raised-button color="primary" (click)="addComment()">
            <mat-icon>add_circle</mat-icon>
            Adicionar
          </button>
          <button mat-button color="warn" (click)="cancelAddingComment()">
            <mat-icon>delete</mat-icon>
            Cancelar
          </button>
        </div>
      </div>
    }

    @if (comments.length === 0) {
      <div class="no-comments">
        Nenhum comentário
      </div>
    }

    @for (comment of comments; track comment) {
      <div class="comment">
        <div class="comment-header">
          <mat-icon>person</mat-icon>
          <span class="author-name">{{ comment.authorName }}</span>
          <span class="comment-date">{{ comment.createDate | date:'dd/MM/yyyy HH:mm:ss' }}</span>
        </div>
        <p class="comment-body">{{ comment.body }}</p>
      </div>
    }

    @if (comments.length > 0) {
      <mat-paginator
        [length]="totalElements"
        [pageSize]="pageSize"
        [pageIndex]="currentPage"
        (page)="onPageChange($event)"
        showFirstLastButtons>
      </mat-paginator>
    }
  </div>
</div>
